import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeFieldinsuranceGroup extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  fieldinsurance_groups_id: "",
                  fieldinsurance_name_en: "",
              fieldinsurance_groups_logo_code: "",
                  imageFildInsurance: "",
                  loading: false,
                  percent: 0,


                  fieldinsurance_name_fa: "",
                  fieldinsurance_groups_parent: "",
                  orderBy: "fieldinsurance_groups_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newDamageHuman: true,
            }
      }

      handleChangeFieldInsuranceName = (event) => {
            this.setState({ fieldinsurance_name_en: event.target.value })
      }
      handleChangeFieldInsuranceId = (event) => {
            this.setState({ fieldinsurance_groups_id: event })
      }

      handleChangeFieldInsuranceDesc = (event) => {
            this.setState({ fieldinsurance_name_fa: event.target.value })
      }

      handleChangeFieldInsuranceGroup = (event) => {
            this.setState({ fieldinsurance_groups_parent: event.target.value })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      onSelectImageFildInsurance = (picture) => {
            this.setState({
                  imageFildInsurance: picture[0],
            })
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        fieldinsurance_groups_id: row2.fieldinsurance_groups_id,
                        fieldinsurance_name_en: row2.fieldinsurance_name_en,
                        fieldinsurance_groups_logo_code: row2.fieldinsurance_groups_logo_code,
                        fieldinsurance_name_fa: row2.fieldinsurance_name_fa,
                        fieldinsurance_groups_parent: row2.fieldinsurance_groups_parent,
                        imageFildInsurance: "",
                        newDamageHuman: false,
                  },
                  () => {}
            )
      }

      newDamageHuman = (event) => {
            this.setState({
                  fieldinsurance_groups_id: "",
                  fieldinsurance_name_en: "",
                  fieldinsurance_groups_logo_code: "",
                  fieldinsurance_name_fa: "",
                  fieldinsurance_groups_parent: "",
                  imageFildInsurance: "",
                  newDamageHuman: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getDamageHuman()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getDamageHuman() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance_groups")

            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      uploadImageFildInsurance = (mode) => {
            const { imageFildInsurance, fieldinsurance_fa } = this.state
            if (imageFildInsurance && imageFildInsurance !== "" && imageFildInsurance !== null) {
                  this.setState({
                        loading: true,
                        percent: 0,
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({
                                          loading: false,
                                          percent: 0,
                                    })
                                    if (mode === "new") {
                                          self.saveNewDamageHuman( arr.data["image_code"])
                                    } else {
                                          self.changeDamageHuman(arr.data["image_code"])
                                    }
                              } else if (arr.result === "error") {
                              }
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "uploadpic")
                  fd.append("image", imageFildInsurance)
                  fd.append("image_name", " تصویر رشته " + fieldinsurance_fa)
                  fd.append("image_desc", "تصویر رشته " + fieldinsurance_fa)
                  fd.append("name", "")
                  xhttp.upload.addEventListener(
                        "progress",
                        function(evt) {
                              if (evt.lengthComputable) {
                                    var percentComplete = evt.loaded / evt.total
                                    self.setState({
                                          percent: percentComplete * 100,
                                    })
                              }
                        },
                        false
                  )
                  xhttp.open("POST", `${constants.BASE_URL}/image`)
                  xhttp.send(fd)
            } else {
                  if (mode === "new") {
                        this.saveNewDamageHuman("")
                  } else {
                        this.changeFildInsurance("")
                  }
            }
      }

      saveNewDamageHuman = (logoCode) => {
            const { fieldinsurance_groups_id, fieldinsurance_name_en, fieldinsurance_name_fa,fieldinsurance_groups_parent } = this.state
            if (fieldinsurance_groups_id != "" && fieldinsurance_name_en != "" && fieldinsurance_name_fa != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getDamageHuman()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_fieldinsurance_groups")
                  fd.append("fieldinsurance_groups_id", fieldinsurance_groups_id)
                  fd.append("fieldinsurance_name_en", fieldinsurance_name_en)
                  fd.append("fieldinsurance_name_fa", fieldinsurance_name_fa)
                  fd.append("fieldinsurance_groups_parent", fieldinsurance_groups_parent)
                  fd.append("fieldinsurance_groups_logo_code", logoCode)
                  xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات گروه رشته بیمه ای  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      deleteDamageHuman = () => {
            const { fieldinsurance_groups_id } = this.state

            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              self.newDamageHuman()
                              self.getDamageHuman()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_fieldinsurance_groups")
            fd.append("fieldinsurance_groups_id", fieldinsurance_groups_id)

            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }


      changeDamageHuman = (logoCode) => {
            const { fieldinsurance_groups_id, fieldinsurance_name_en, fieldinsurance_name_fa ,fieldinsurance_groups_parent} = this.state
            if (fieldinsurance_groups_id != "" && fieldinsurance_name_en != "" && fieldinsurance_name_fa != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getDamageHuman()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_fieldinsurance_groups")
                  fd.append("fieldinsurance_groups_id", fieldinsurance_groups_id)
                  fd.append("fieldinsurance_name_en", fieldinsurance_name_en)
                  fd.append("fieldinsurance_name_fa", fieldinsurance_name_fa)
                  fd.append("fieldinsurance_groups_parent", fieldinsurance_groups_parent)
                  if (logoCode !== "") {
                        fd.append("fieldinsurance_groups_logo_code", logoCode)
                  }
                    xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات گروه رشته بیمه ای  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }



      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      render() {
            const { classes } = this.props
            const {
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newDamageHuman,
                  fieldinsurance_groups_id,
                  fieldinsurance_name_en,
                  fieldinsurance_groups_logo_code,
                  fieldinsurance_name_fa,
                  fieldinsurance_groups_parent,
                  loading,
                  percent,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                      <Grid item xs={6}>
                                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                                  <img alt="" className={classes.large} src={fieldinsurance_groups_logo_code} />
                                                            </div>
                                                      </Grid>

                                                            <Grid item xs={12}></Grid>

                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        <FloatingLabelInput
                                                                              type="number"
                                                                              placeholder="آی دی گروه رشته بیمه ای "
                                                                              handleInputt={this.handleChangeFieldInsuranceId}
                                                                              value={fieldinsurance_groups_id}
                                                                        />
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام گروه رشته بیمه ای "
                                                                        handleInputt={this.handleChangeFieldInsuranceName}
                                                                        value={fieldinsurance_name_en}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput


                                                                        placeholder="نام فارسی گروه رشته بیمه ای  "
                                                                        handleInputt={this.handleChangeFieldInsuranceDesc}
                                                                        value={fieldinsurance_name_fa}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput


                                                                        placeholder="گروه بالایی این گروه"
                                                                        handleInputt={this.handleChangeFieldInsuranceGroup}
                                                                        value={fieldinsurance_groups_parent}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="تصویر رشته را انتخاب نمایید"
                                                                        onChange={this.onSelectImageFildInsurance}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newDamageHuman ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadImageFildInsurance("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت گروه رشته بیمه ای  جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newDamageHuman}
                                                                              >
                                                                                    {"گروه رشته بیمه ای  جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                            this.uploadImageFildInsurance("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.deleteDamageHuman()
                                                                                    }}
                                                                              >
                                                                                    {"حذف"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>

                                                                        <TableCell
                                                                        >
                                                                              {" "}
                                                                        </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_groups_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "fieldinsurance_groups_id" ? order : false
                                                                                    }
                                                                              >
                                                                                    {"آیدی گروه رشته بیمه ای  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_groups_id"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_groups_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_groups_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_name_en"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام گروه رشته بیمه ای  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_name_en"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_name_en"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_name_en")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_name_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام فارسی گروه رشته بیمه ای  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_name_fa"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_name_fa"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "fieldinsurance_name_fa"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"fieldinsurance_groups_parent"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"گروه بالایی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_groups_parent"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_groups_parent"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "fieldinsurance_groups_parent"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["fieldinsurance_groups_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >

                                                                                          <TableCell>
                                                                                                <img
                                                                                                      className={classes.small}
                                                                                                      alt=""
                                                                                                      src={row["fieldinsurance_groups_logo_code"]}
                                                                                                />
                                                                                          </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_groups_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_groups_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_name_en"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_name_en"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_name_fa"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_name_fa"]}
                                                                                                </TableCell>


                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_groups_parent"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_groups_parent"]}
                                                                                                </TableCell>


                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeFieldinsuranceGroup)
